module.exports = __webpack_public_path__ + "static/media/logo.caa4f357.png";